export const COMPANY_CONTACT = {
  email: 'contact@scalenix.fr',
  phone: '+33 6 33 60 90 30',
  address: {
    street: '27 Rue Anatoile Celle',
    city: 'Chaponost',
    postalCode: '69630',
    country: 'France'
  }
};